import type { fabric } from 'fabric';
import type { ObjectTypeDefinition } from '../interfaces/object-type';

export class ObjectRegistry {
  private readonly defs = new Map<string, ObjectTypeDefinition<any>>();

  register<TProps>(def: ObjectTypeDefinition<TProps>): void {
    if (this.defs.has(def.kind)) {
      throw new Error(`Object type "${def.kind}" is already registered.`);
    }
    this.defs.set(def.kind, def as ObjectTypeDefinition<unknown>);
  }

  get<TProps = unknown>(kind: string): ObjectTypeDefinition<TProps> | undefined {
    return this.defs.get(kind) as ObjectTypeDefinition<TProps> | undefined;
  }

  create<TProps>(kind: string, props: TProps): fabric.Object {
    const def = this.defs.get(kind);
    if (!def) throw new Error(`Object type "${kind}" is not registered.`);
    return (def as ObjectTypeDefinition<TProps>).create(props);
  }

  has(kind: string): boolean {
    return this.defs.has(kind);
  }

  kinds(): string[] {
    return Array.from(this.defs.keys());
  }
}
